module.exports = __webpack_public_path__ + "img/donuts.61759cc4.png";